class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    this.notification.addEventListener(
      'transitionend',
      () => {
        if (!this.notification.classList.contains('active')) {
          this.notification.classList.remove('animate');
        }
      },
      { once: true }
    );

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    
    // If it's a bundle addition, prioritize the parent product's key
    if (parsedState.items && parsedState.items.length > 1) {
      const parentItem = parsedState.items.find(item => item.properties && item.properties._bundle_type === 'parent');
      if (parentItem) {
        this.cartItemKey = parentItem.key;
      }
    }

    this.getSectionsToRender().forEach((section) => {
      const parentElement = document.getElementById(section.id);
      if (!parentElement) return;

      const elementToReplace = section.selector ? parentElement.querySelector(section.selector) : parentElement;
      if (elementToReplace && parsedState.sections && parsedState.sections[section.id]) {
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    });

    if (this.header) this.header.reveal();
    
    // Prioritize the parent product in the notification for image/metadata display
    let itemToShow = parsedState;
    if (parsedState.items && parsedState.items.length > 1) {
      const parentItem = parsedState.items.find(item => item.properties && item.properties._bundle_type === 'parent');
      if (parentItem) {
        itemToShow = parentItem;
      }
    }

    this.open();
    

  }

  getSectionsToRender() {
    return [

      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const element = doc.querySelector(selector);
    return element ? element.innerHTML : '';
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
